import { render, staticRenderFns } from "./PI3.vue?vue&type=template&id=2f60c535&scoped=true&"
import script from "./PI3.vue?vue&type=script&lang=js&"
export * from "./PI3.vue?vue&type=script&lang=js&"
import style0 from "./PI3.vue?vue&type=style&index=0&id=2f60c535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f60c535",
  null
  
)

export default component.exports